import React from "react";
import "./services.css";

import services from "../../assets/servicesdata";

function Services() {
  return (
    <section className="services-section">
      <div className="container">
        <div className="section-header">
          <p className="section-sub">\ What We Do \</p>
          <h2 className="section-title">Our Services</h2>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <img
                src={service.image}
                alt={service.title}
                className="service-image"
              />
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
